import { INeoAction } from './../Actions.interface';
import { STATUS, REQUEST_ACTIONS } from '../../Constants/Actions.constants';
import { IProduct } from '../../Models/DTO/Product.models';

export interface EventProductState {
  products: IProduct[];
}

const INITIAL: EventProductState = {
  products: [],
};

export default (state: EventProductState = INITIAL, action: INeoAction): EventProductState => {
  const { status, payload, name } = action;

  if (name !== REQUEST_ACTIONS.EVENT_PRODUCTS) {
    return state;
  }

  if (status === STATUS.SUCCESS) {
    return {
      products: payload,
    };
  }

  return state;
};
